module.exports = __webpack_public_path__ + "img/shou toramaru_sc1.ae189346.png";